<template>
	<div class="NavBarv2">
		<nav class="nav py-4 lg:py-0">
			<div class="nav__logo">
				<!-- <span @click="redirectToPage('/')">
					NymbleUp
				</span> -->
				<!-- <router-link tag="a" to="/" exact style="color: #e29d5a; text-decoration: none;">NymbleUp</router-link> -->
				<router-link tag="a" to="/" exact style="color: #e29d5a; text-decoration: none;">
					<img src="../assets/images/logo.png" alt="Nymbleup" width="240" style="margin-top: 20px" />
				</router-link>
			</div>

			<div class="block lg:hidden" style="margin-left: auto;" @click="toggleMenu = !toggleMenu">
				<button class="flex items-center px-3 py-2 border border-rounded text-amp border-amp hover:text-amp-btn2 hover:border-amp-btn2 focus:outline-none">
					<svg
						class="fill-current h-3 w-3"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<title>Menu</title>
						<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
					</svg>
				</button>
			</div>

			<!-- desktop version -->
			<div class="menu-wrapper md:hidden" style="margin-left: 30px;">
				<div v-if="$route.name != 'VideoPage'" class="hidden lg:block">
					<ul class="nav__items">
						<li class="nav__products--dd hover:text-amp-text2" style="height: 100%;">
							<div class="nav-menu-item">
								Solutions
								<i class="el-icon-arrow-down" />
							</div>

							<ul class="dropdown-wrapper">
								<!-- <li class="cursor-pointer" @click="() => $router.push({ name: 'aiForecasting&RecommendationEngine' })"> -->
								<li class="cursor-pointer">
									<router-link
										tag="a"
										to="/ai-forecasting-and-reco-engine"
										style="color: #4d4d4d; text-decoration: none;"
									>Forecasting and Recommendation Engine</router-link>
								</li>
								<!-- <li class="cursor-pointer" @click="() => $router.push({ name: 'workForceScheduling' })"> -->
								<li class="cursor-pointer">
									<router-link
										tag="a"
										to="/workforce-scheduling"
										style="color: #4d4d4d; text-decoration: none;"
									>Workforce Management and Scheduling</router-link>
								</li>
								<!-- <li class="cursor-pointer" @click="() => $router.push({ name: 'demandPlanning' })"> -->
								<li class="cursor-pointer">
									<router-link
										tag="a"
										to="/demand-planning"
										style="color: #4d4d4d; text-decoration: none;"
									>Demand Planning</router-link>
								</li>
								<li>
									Expiry Tracking and Management
								</li>
							</ul>
						</li>
						<li>
							<!-- <div class="nav-menu-item" @click="redirectToPage('/about-us')"> -->
							<div class="nav-menu-item">
								<router-link
									tag="a"
									to="/about-us"
									style="color: #4d4d4d; text-decoration: none;"
								>About Us</router-link>
							</div>
						</li>
					</ul>
				</div>

				<div v-if="$route.name != 'VideoPage'" class="hidden lg:block" style="margin-left: auto;">
					<div class="nav__items">
						<div class="nav-menu-item">
							<el-button class="request-demo-btn" @click="() => $router.push({ name: 'ContactUsRequestDemo' }).catch(()=>{})">
								Request Demo
							</el-button>
						</div>
						<div>
							<el-button class="nav-bar-btn" size="medium" @click="() => $router.push({ path: 'login' }).catch(()=>{})">LOGIN</el-button>
						</div>
					</div>
				</div>
			</div>
		</nav>

		<!-- mobile version -->
		<div v-if="toggleMenu" class="lg:hidden block w-full px-4">
			<div class="text-sm lg:flex-grow">
			</div>
		</div>
		<div v-if="toggleMenu && $route.name != 'VideoPage'" class="lg:hidden block flex flex-col items-start">
			<div style="width: 100%; padding: 5px 15px;">
				<el-collapse v-model="toggleMobileNavMenu" accordion style="border: none;">
					<el-collapse-item name="1">
						<template slot="title">
							<div class="mobile-nav-menu">
								Solutions
							</div>
						</template>
						<div class="mobile-nav-sub-menu cursor-pointer" @click="() => $router.push({ name: 'aiForecasting&RecommendationEngine' }).catch(()=>{})">
							Forecasting and Recommendation Engine
						</div>
						<div class="mobile-nav-sub-menu cursor-pointer" @click="() => $router.push({ name: 'workForceScheduling' }).catch(()=>{})">
							Workforce Management and Scheduling
						</div>
						<div class="mobile-nav-sub-menu">
							Demand Planning
						</div>
						<div class="mobile-nav-sub-menu">
							Expiry Tracking and Management
						</div>
					</el-collapse-item>
				</el-collapse>

				<div class="mobile-nav-menu" @click="redirectToPage('/about-us')">
					About Us
				</div>

				<div class="mobile-nav-menu mt-2" @click="() => $router.push({ name: 'ContactUsRequestDemo' }).catch(()=>{})">
					Request Demo
				</div>

				<div class="mt-4">
					<el-button class="nav-bar-btn" size="medium" @click="openLoginModel()">LOGIN</el-button>
				</div>

			</div>
		</div>
		<LoginAndFreeTrial v-if="showLoginModel" />
	</div>
</template>
<script>
export default {
	name: "NavBarV2",
	data() {
		return {
			toggleMenu: false,
			toggleProducts: false,
			toggleMobileNavMenu: 0
		};
	},
	computed: {
		showLoginModel() {
			// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
			return this.$store.state.show_login_and_freeTrial_model;
		}
	},
	methods: {
		goReqeustDemo() {
			this.$router.push({ path: '/request-demo' }).catch(()=>{});
		},
		hideProductsDropdown() {
			this.toggleProducts = false;
		},
		openLoginModel() {
			// debugger;
			// this.$router.push("/user-registration/start-free-trial-and-login");
			this.$store.commit("showFreeTrialModel", false);
			this.$store.commit("openLoginModel", true);
		},
		openFreeTrialModel() {
			// this.$router.push("/user-registration/start-free-trial-and-login");
			this.$store.commit("showFreeTrialModel", true);
			this.$store.commit("openLoginModel", true);
		},
		redirectToPage(pageName) {
			this.$router.push({ path: pageName }).catch(()=>{});
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../assets/css/variable.scss";
ul {
	list-style-type: none;
	padding-inline-start: 0;
}
a {
	text-decoration: none;
}
.NavBarv2 {
	box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
	position: fixed;
    z-index: 111;
    width: 100%;
    background: #fff;
	top:0;
	// height: px;
	// margin-bottom: 0.5rem;
}
.NavBarv2 .nav {
	box-sizing: border-box;
	display: flex;
	// justify-content: space-between;
	align-items: center;
	margin: 0 1rem;
	height: 60px;
	.menu-wrapper{
		display: flex; align-items: center; width: 100%;
	}
	// background: lightgoldenrodyellow;
}
.nav-bar-btn{
	background-color: #E29D5A;
	border-color: #E29D5A;
	color: #fff;
	min-width: 55px;
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 1.1px;
}
.nav-bar-btn:hover, .nav-bar-btn:focus, .nav-bar-btn:visited, .nav-bar-btn:active {
	background-color: #fff;
	border-color: #E29D5A;
	color: #E29D5A;
}
.NavBarv2 .nav__logo {
	color: #E29D5A;
	cursor: pointer;
	font-size: 24px;
	font-weight: bold;
}
.NavBarv2 .nav__items {
	display: flex;
	align-items: center;
	// font-size: $font-size-sm;
}
.request-demo-btn{
	border: 1px solid #000;
	color: #000;
	font-size: 14px;
	font-weight: 500;
	padding: 5px;
	height: 34px;
	width: 130px;
	transition: 0.3s;
	cursor: pointer;
}
.request-demo-btn:hover{
	border: 1px solid #000;
	color: #000;
	background-color: #fff;
}
.nav-menu-item{
	padding: 0 15px;
	cursor: pointer;
}
.NavBarv2 .nav__items > li {
	font-size: 16px;
	color: #4d4d4d;
	padding: 1rem 0;
}
.NavBarv2 .nav__items > li:last-of-type {
	margin-right: 0;
}
.NavBarv2 .nav__items > .nav__products--dd:hover i {
	color: $text-color;
}
.NavBarv2 .dropdown-wrapper{
	li {
		padding: 0.6rem 1rem;
		transition: background 0.4s ease, color 0.2s ease;
		font-size: 0.8rem;
	}
}
.NavBarv2 .dropdown-wrapper li:hover {
	background: #eff5ff;
	color: #E29D5A;
	// transition: all 0.4s ease;
}
.NavBarv2 .nav__products--dd {
	position: relative;
}
.NavBarv2 .nav__products--dd ul {
	margin-top: 1rem;
	box-shadow: rgba(0, 0, 0, 0.2) 1px 3px 3px;
	// margin: 0.5rem 0;
	// padding-top: 2rem;
	background: #fff;

	position: absolute;
	z-index: 10;
	width: 240px;
	transition: all 0.4s ease;
	display: none;
}
.NavBarv2 .nav__products--dd:hover ul {
	display: block;
	font-size: $font-size-sm;
}
.NavBarv2 .nav__buttons {
	@extend .amp-btn;
	// font-family: $karla-bold;
	transition: all 0.4s ease;
}
.NavBarv2 .nav__buttons:hover {
	color: $text-color;
	transition: all 0.4s ease;
}
.NavBarv2 {
	.mobile-nav-menu{
		font-size: 16px;
		color: #4d4d4d;
		padding: 5px 0;
	}
	.mobile-nav-sub-menu{
		font-size: 14px;
		padding: 5px 0;
	}
	.mobile-nav-sub-menu:hover{
		color: #e29d5a;
	}
}

@media screen and (max-width: 992px) {
	.menu-wrapper{
		display: none!important;
	}
}
</style>
<style lang="scss">
.NavBarv2 .el-collapse {
	border: none;
	.el-collapse-item__header, .el-collapse-item__wrap{
		border: none;
	}
}
</style>
